module.exports = __webpack_public_path__ + "media/src/images/icons/success/green-b975aa3a56a61702cae4417ec7d79e13.svg";